module.exports = __webpack_public_path__ + "img/PPT版_03.25ed0c78.png";